import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getListMaterial = createAsyncThunk('getListMaterial/get', async (data, { rejectWithValue }) => {
    const token = localStorage.getItem('accessToken')
    try {
        const response = await axios({
            method: 'get',
            url: `${process.env.REACT_APP_DASHBOARD_SERVICE_URL}/dashboard/material/list`,
            headers: {
                "Authorization": `Bearer ${token}`
            },
            // data: data
        })
        return response.data
    } catch (error) {
        console.log(error.response, 'error response')
        return rejectWithValue(error)
    }
})